import { Logo } from '@components/common/Logo';
import { useAuthStore } from '../store/authStore';

export function ServiceUnavailablePage() {
  const tenantInfo = useAuthStore((s) => s.tenantInfo);
  const tenantLogo = tenantInfo?.logo || null;
  const tenantName = tenantInfo?.name || 'Facturación Electrónica';
  const year = new Date().getFullYear();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-secondary-900 via-primary-900 to-secondary-800 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-hard overflow-hidden">

          {/* Logo */}
          <div className="px-8 pt-8 pb-6 flex justify-center">
            {tenantLogo ? (
              <img src={tenantLogo} alt={tenantName} className="h-16 object-contain" />
            ) : (
              <Logo height={56} />
            )}
          </div>

          <hr className="border-secondary-200" />

          {/* Contenido principal */}
          <div className="px-8 py-8 text-center">
            {/* Ícono de advertencia */}
            <div className="flex justify-center mb-5">
              <svg
                className="w-14 h-14 text-teal-500"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                  fill="rgba(18,196,178,0.15)"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="12" y1="9" x2="12" y2="13"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                />
                <circle cx="12" cy="17" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="1.5" />
              </svg>
            </div>

            <h1 className="text-xl font-bold text-secondary-900 mb-3">
              Servicio temporalmente no disponible
            </h1>
            <p className="text-secondary-600 text-sm leading-relaxed mb-8">
              Estamos experimentando dificultades técnicas. Nuestro equipo ya fue notificado y está trabajando para resolverlo.
            </p>

            {/* Botón reintentar */}
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center gap-2 px-8 py-3 bg-teal-500 hover:bg-teal-600 active:bg-teal-700 text-white font-semibold rounded-lg shadow-medium transition-colors"
              data-testid="auth-service-unavailable-retry-button"
            >
              <svg
                className="w-4 h-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Reintentar
            </button>

            {/* Enlace de soporte */}
            <p className="mt-6 text-sm text-secondary-500">
              Si el problema persiste, contacte a{' '}
              <a
                href="mailto:soporte@hypernovalabs.com"
                className="text-teal-600 hover:text-teal-700 underline underline-offset-2 transition-colors"
                data-testid="auth-service-unavailable-support-link"
              >
                soporte
              </a>
            </p>
          </div>

          {/* Footer */}
          <div className="bg-teal-600 py-4 px-6 text-center">
            <p className="text-white text-sm font-medium">
              Copyright © {year} Hypernovalabs {tenantName}
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
